<template>
  <div class="departmentManage">
    <el-container>
      <el-aside
        width="240px"
        style="padding-right:10px;overflow: auto;background: #fff;border-radius: 4px;"
      >
        <div class="title-add">
          <div style="margin-left:10px;">部门</div>
        </div>
        <tree @setIds="setIdEvent"></tree>
      </el-aside>
      <el-main style="margin-top:-20px;padding-bottom:0px;">
        <el-card class="box-card" style="margin-top: 20px;">
          <el-row :span="24">
            <el-col :span="12">
              <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">添加部门</el-button>
            </el-col>
          </el-row>
          <el-table
            ref="multipleTable"
            :data="page.rows"
            v-loading="loading"
              element-loading-text="拼命加载中"
              element-loading-background="rgba(255, 255, 255, 0.8)"
            tooltip-effect="dark"
            style="margin-top: 20px; width: 100%;"
            border
            @selection-change="selectionChange"
          >
            <el-table-column show-overflow-tooltip prop="sort" width="60" label="排序"></el-table-column>
            <el-table-column show-overflow-tooltip prop="name" label="部门名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="phone" label="部门电话"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="备注"></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="remark"
              label="状态"
              width="150"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  @click="onDepartment(scope.row.id,scope.row.state)"
                  style="color:#4d94ff"
                >{{scope.row.state==1?"启用":"禁用"}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop label="操作" width="100" align="center">
              <template slot-scope="scope">
                <div class="operationGroup">
                  <span @click="editFormEvent(scope.row)">编辑</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next"
            style="margin-top: 20px;text-align: right;"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </el-card>
      </el-main>
    </el-container>

    <el-dialog title="添加部门" :visible.sync="addFormVisible" width="30%" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <!-- <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="上级部门" prop="pid">
              <el-input v-if="addsty" disabled placeholder="请输入上级部门" v-model="names"></el-input>
              <el-cascader
                v-else
                style="width:100%"
                clearable
                v-model="addForm.pid"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请输入上级部门"
                :options="treeData"
                @change="subjectSearchChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="部门名称" prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="请输入部门名称"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="显示排序" prop="sort">
              <el-input
                type="number"
                v-model="addForm.sort"
                placeholder="请输入显示排序"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="部门电话" prop="resource">
              <el-input
                v-model="addForm.phone"
                placeholder="请输入部门电话"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="备注说明" prop="remark">
              <el-input
                type="textarea"
                :rows="3"
                v-model="addForm.remark"
                placeholder="请输入备注"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="是否启用" prop="enabled">
              <!-- <el-radio v-model="addForm.state" :label=1>启用</el-radio>
              <el-radio v-model="addForm.state" :label=-1>禁用</el-radio>-->
              <el-radio-group v-model="addForm.state">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="2">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="reset()">重 置</el-button>
        <el-button type="primary" @click="addAgentRoleInfo">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改信息" :visible.sync="editFormVisible" width="30%" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="部门名称" prop="name">
              <el-input
                v-model="editForm.name"
                placeholder="请输入部门名称"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="显示排序" prop="sort">
              <el-input
                type="number"
                v-model="editForm.sort"
                placeholder="请输入显示排序"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="部门电话" prop="resource">
              <el-input
                v-model="editForm.phone"
                placeholder="请输入部门电话"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="备注说明" prop="remark">
              <el-input
                type="textarea"
                :rows="3"
                v-model="editForm.remark"
                placeholder="请输入备注"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="是否启用" prop="enabled">
              <el-radio v-model="editForm.state" :label="1">启用</el-radio>
              <el-radio v-model="editForm.state" :label="-1">禁用</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="reset()">重 置</el-button>
        <el-button type="primary" @click="updateAgentRoleInfo">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import tree from "./tree";
export default {
  components: { tree },
  data() {
    return {
      addsty: false,
      manageButton: "启用",
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      addFormVisible: false,
      editFormVisible: false,
      searchForm: {},
      addForm: {
        name: "",
        remark: "",
        phone: "",
        state: 1
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入题型名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "题型名称长度在1到255个字"
          }
        ],
        phone: [
          { required: true, message: "请输入部门电话", trigger: "blur" },
          {
            pattern: /^1(3|4|5|7|8)\d{9}$/,
            message: "手机号格式不正确"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ],
        remark: ""
      },
      editForm: {
        name: "",
        remark: "",
        phone: "",
        state: 1
      },
      editFormRules: {
        phone: [
          { required: true, message: "请输入部门电话", trigger: "blur" },
          {
            pattern: /^1(3|4|5|7|8)\d{9}$/,
            message: "手机号格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入题型名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "题型名称长度在1到255个字"
          }
        ],
        remark: ""
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      names: "",
      multipleSelection: "",
      ids: [],
      treeData: [],

      fileAction: `${process.env.BASE_URL}/questionType/upload`,
      fileList: [],
      loading: false
    };
  },
  methods: {
    subjectSearchChange() {
      if (this.addForm.pid) {
        this.addForm.pid = this.addForm.pid[this.addForm.pid.length - 1];
      } else {
        this.addForm.pid = "";
      }
      console.log(this.addForm.pid);
    },
    setIdEvent(val) {
      console.log(val);
      // this.addForm.pid = val.id;
      // this.names = val.name;
      // this.addsty = true;
      this.api.department
        .getNewDepartmentListByTreeId({
          pid: String(val.id)
        })
        .then(res => {
          console.log(res)
          if (res.success) {
            this.page.rows = res.data;
            // this.statistics = [];
            // for (var i in res.data) {
            //   if (i == 0) {
            //     this.statistics.push(1);
            //     this.pos = 0;
            //   } else {
            //     // 判断这一条和上一条id是否相同
            //     if (res.data[i].pid === res.data[i - 1].pid) {
            //       this.statistics[this.pos] += 1;
            //       this.statistics.push(0);
            //     } else {
            //       this.statistics.push(1);
            //       this.pos = i;
            //     }
            //   }
            // }
          } else {
            this.$message.error(res.message);
          }
        });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },

    pageList() {
      this.loading = true;
      let obj = {
        id: JSON.parse(localStorage.getItem("user")).agentId,
        pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber
      };
      this.api.department
        .pageList(obj)
        .then(res => {
          this.loading = false;
          this.page.rows = res.data.records;
          this.page.total = res.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    editFormEvent(row) {
      (this.editForm = row), (this.editFormVisible = true);
    },
    onDepartment(id, state) {
      this.$confirm("您确定要禁用/启用吗？", "系统消息", {
        type: "warning"
      }).then(() => {
        if (state == -1) {
          this.api.department.onDepartment({ id: id }).then(result => {
            if (result.success) {
              this.$message({
                type: "success",
                message: result.message
              });
              this.pageList();
            } else {
              this.$message({
                type: "error",
                message: result.message
              });
            }
          });
        } else {
          this.api.department.offDepartment({ id: id }).then(result => {
            if (result.success) {
              this.$message({
                type: "success",
                message: result.message
              });
              this.pageList();
            } else {
              this.$message({
                type: "error",
                message: result.message
              });
            }
          });
        }
      });
    },
    addAgentRoleInfo() {
      if (
        this.addForm.phone != null &&
        this.addForm.phone != "" &&
        !/^1[2,3,4,5,6,7,8,9]\d{9}$/.test(this.addForm.phone)
      ) {
        alert("手机号码有误，请检查后重填");
        return false;
      } else {
        this.$refs.addForm.validate(valid => {
          if (valid) {
            this.addForm.agentId = JSON.parse(
              localStorage.getItem("user")
            ).agentId;
            this.api.department
              .addDepartment(this.addForm)
              .then(result => {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.addFormVisible = false;
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            return false;
          }
        });
      }
    },
    updateAgentRoleInfo() {
      if (
        this.editForm.phone != null &&
        this.editForm.phone != "" &&
        !/^1[2,3,4,5,6,7,8,9]\d{9}$/.test(this.editForm.phone)
      ) {
        alert("手机号码有误，请检查后重填");
        return false;
      } else {
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.editForm.agentId = this.loginData.agentId;
            this.api.department
              .updateDepartment(this.editForm)
              .then(result => {
                if (result.success) {
                  this.$message({
                    type: "success",
                    message: result.message
                  });
                  this.editFormVisible = false;

                  this.pageList();
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            return false;
          }
        });
      }
    },

    reset() {
      this.addForm.name = "";
      this.addForm.state = 1;
      this.addForm.remark = "";
      this.addForm.phone = "";
      this.editForm.name = "";
      this.editForm.state = 1;
      this.editForm.remark = "";
      this.editForm.phone = "";
    },
    getTree() {
      this.api.department
        .getNewDepartmentTreeList({})
        .then(res => {
          this.webLoading = false;

          this.treeData = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
      }
    }
  },
  mounted() {
    this.pageList();
    this.getTree();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/departmentManage/index.vue